import { render, staticRenderFns } from "./AllCkeditorComponent.vue?vue&type=template&id=32a0fe9a"
import script from "./AllCkeditorComponent.vue?vue&type=script&lang=js"
export * from "./AllCkeditorComponent.vue?vue&type=script&lang=js"
import style0 from "./AllCkeditorComponent.vue?vue&type=style&index=0&id=32a0fe9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports